import ActionTypeItem from "../ActionTypeItem";

export default class BuscarItems extends ActionTypeItem{
    ejecutar(estado, nuevoEstado) {    
        nuevoEstado.flag.procesandoComando = true;
        // nuevoEstado.flag.sensorDeAccionABuscar = !(estado.flag.sensorDeAccionABuscar);
        return nuevoEstado;
    }
}